import { createReducer } from 'redux-create-reducer'
import type { Contact } from 'types/list'
import type { Playlist } from 'types/playlist'
import {
  CONTACTS_CREATE_SUCCESS,
  CONTACTS_IMPORT_SUCCESS,
  CONTACTS_LOAD_SUCCESS,
  CONTACTS_UPDATE_SUCCESS,
  PLAYLIST_LOAD_BATCH,
  PLAYLIST_LOAD_PLAIN_UPDATE,
  PRELOAD_DATA_ON_LOGIN,
  TAGS_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
export type State = {
  contact_tags: string[]
  playlist_tags: string[]
}
const initialState: State = {
  contact_tags: [],
  playlist_tags: [],
}

const sortFunc = (a, b) => {
  if (a.toLowerCase() < b.toLowerCase()) return -1
  if (a.toLowerCase() > b.toLowerCase()) return 1
  return 0
}

type TagContainer = Playlist | Contact

const updateTagsFromArray = (currentTags: string[], array: TagContainer[]) => {
  const tags = [
    ...new Set(
      array.flatMap(p => p.tags).filter((t): t is string => t != null),
    ),
  ]
  // update tags for convenience, but evade generating new objects
  // if nothing changed
  const diff = tags.filter(t => currentTags.indexOf(t) === -1)
  if (diff.length > 0) return [...currentTags, ...diff].sort(sortFunc)
  return currentTags
}

const getTags = (state: State, tags) => {
  if (tags) {
    return {
      playlist_tags: (tags.playlist_tags.slice() || []).sort(sortFunc),
      contact_tags: (tags.contact_tags.slice() || []).sort(sortFunc),
    }
  }

  return state
}

const updateTags = (
  state: State,
  key: 'contact_tags' | 'playlist_tags',
  array: TagContainer[],
) => ({
  ...state,

  [key]: updateTagsFromArray(state[key] || [], array),
})

export const tagsReducer = createReducer<State, any>(initialState, {
  [PRELOAD_DATA_ON_LOGIN](state, { entities }) {
    return getTags(state, entities.tags)
  },

  [TAGS_LOAD_SUCCESS](state, { tags }) {
    return getTags(state, tags)
  },

  [PLAYLIST_LOAD_BATCH](state, { list }) {
    return updateTags(state, 'playlist_tags', list)
  },

  [PLAYLIST_LOAD_PLAIN_UPDATE](state, { playlists }) {
    return updateTags(state, 'playlist_tags', playlists)
  },

  [CONTACTS_LOAD_SUCCESS](state, { contacts }) {
    return updateTags(state, 'contact_tags', contacts)
  },

  [CONTACTS_CREATE_SUCCESS](state, { contact }) {
    return updateTags(state, 'contact_tags', [contact])
  },

  [CONTACTS_UPDATE_SUCCESS](state, { contacts }) {
    return updateTags(state, 'contact_tags', contacts)
  },

  [CONTACTS_IMPORT_SUCCESS](state, { contacts }) {
    return updateTags(state, 'contact_tags', contacts)
  },
})
